module.exports = [{"path":"wordpress","name":"WordPress"},{"path":"site-templates","name":"HTML"},{"path":"marketing","name":"Marketing"},{"path":"cms-themes","name":"CMS"},{"path":"ecommerce","name":"eCommerce"},{"path":"muse-templates","name":"Muse"},{"path":"sketch-templates","name":"UI Design"},{"path":"psd-templates","name":"PSD Templates"},{"path":"blogging","name":"Blogging"},{"path":"courses","name":"Courses"},{"path":"forums","name":"Forums"},{"path":"typeengine-themes","name":"TypeEngine Themes"}]


//////////////////
// WEBPACK FOOTER
// ./config/sites/categories/themeforest.json
// module id = 246
// module chunks = 1 2 3